import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAllerALaFiche } from './useAllerALaFiche';

/**
 * `/bulle/:id`, l'adresse de la fiche d'une bulle (chantier notifications-socle, ticket 03) : le
 * toucher d'une notification ouvre l'app ici. Elle mène à la feuille de la mère de la bulle, sa
 * fiche ouverte, comme un toucher dans un projet (`useAllerALaFiche`), et remplace sa propre
 * adresse dans l'historique. Une bulle partie ou sans réseau : sa propre feuille, qui dira ce
 * qu'il en est.
 */
export function VersLaFiche() {
  const { id } = useParams<{ id: string }>();
  const allerALaFiche = useAllerALaFiche();

  useEffect(() => {
    if (id) void allerALaFiche(id, { remplacer: true });
    // Une fois par adresse : le crochet rend une fonction neuve à chaque rendu, elle n'en est pas.
  }, [id]);

  // Rien de clignotant le temps de lire la feuille, comme à l'ouverture de l'app.
  return null;
}
